export function useEventHandlers() {
	const clickDelay = (handler: (...args: any) => any, delay = 150) => {
		setTimeout(handler, delay)
	}

	return {
		clickDelay
	}
}
